import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HouseholdRecordVm } from '@k12/models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminHouseholdRecordService {
  private readonly http: HttpClient = inject(HttpClient);

  getHouseholdDetails(programPartnerId: string): Observable<HouseholdRecordVm> {
    // Omit the param when there's no id rather than sending an empty value: the API binds it as a
    // Guid and a present-but-empty query value is a binding failure, not a null.
    const params: Record<string, string> = {};
    if (programPartnerId) {
      params['programPartnerId'] = programPartnerId;
    }
    return this.http.get<HouseholdRecordVm>(`${environment.adminApiUrl}/household/details`, { params });
  }
}